import { useEffect } from 'react'

export const useBicField = (
  iban: string | null,
  bic: string | null,
  bicFieldName: string,
  setFieldValue: (field: string, value: string | null) => void
) => {
  const isBicFieldVisible =
    iban !== null && iban.trim().length >= 2 && !iban.match(/^\s*FI/i)

  useEffect(() => {
    if (!isBicFieldVisible && bic !== null) {
      setFieldValue(bicFieldName, null)
    }
  }, [isBicFieldVisible, bic, bicFieldName, setFieldValue])

  return {
    isBicFieldVisible,
  }
}
